import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { EFMigrationsHistory } from "../models/ef-migrations-history.model";

@Injectable()
export class EFMigrationsHistoryService {

    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<EFMigrationsHistory[]>(this.getBaseUrl() + "/api/EFMigrationsHistory");
    }

    private getBaseUrl() {
        return (location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : ""));
    }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/efmigrations-history.service.ts